export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export function createNavigationRoutes(user?: { is_superuser: boolean; role_id?: number, manages_venues: Array<number>}) {

  const base: INavigationRoute[] = [
    { name: 'dashboard', displayName: 'menu.dashboard', meta: { icon: 'vuestic-iconset-dashboard' } },
    { name: 'vendors', displayName: 'menu.vendors', meta: { icon: 'store' } }
  ]

  if (user && (user.is_superuser || (user.role_id !== undefined && user.role_id <= 1))) {
    base.splice(1, 0, { name: 'venues', displayName: 'menu.venues', meta: { icon: 'warehouse' } })
  }

  return {
    root: { name: '/', displayName: 'navigationRoutes.home' },
    routes: base,
  }
}
